"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upgradeProductToActivationType = exports.productActivationProducts = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _UpgradeProducts = require("self-service-api/constants/UpgradeProducts");

var _upgradeProductToActi;

var productActivationProducts = [_UpgradeProducts.CRM, // TODO can delete after CMS Hub launch (4/7/20)
_UpgradeProducts.CMS, _UpgradeProducts.SALES_FREE, _UpgradeProducts.MARKETING_FREE, _UpgradeProducts.SERVICE_FREE, _UpgradeProducts.CMS_ENTERPRISE, _UpgradeProducts.CMS_PROFESSIONAL];
exports.productActivationProducts = productActivationProducts;
var activationTypes = {
  HUBSPOT_SALES: 'HUBSPOT_SALES',
  MARKETING_FREE: 'MARKETING_FREE',
  SERVICE_FREE: 'SERVICE_FREE',
  CMS: 'CMS_FREE',
  CRM: 'CRM',
  CMS_ENTERPRISE: 'CMS_FREE',
  CMS_PROFESSIONAL: 'CMS_FREE'
};
var upgradeProductToActivationType = (_upgradeProductToActi = {}, (0, _defineProperty2.default)(_upgradeProductToActi, _UpgradeProducts.SALES_FREE, activationTypes.HUBSPOT_SALES), (0, _defineProperty2.default)(_upgradeProductToActi, _UpgradeProducts.MARKETING_FREE, activationTypes.MARKETING_FREE), (0, _defineProperty2.default)(_upgradeProductToActi, _UpgradeProducts.CMS, activationTypes.CMS), (0, _defineProperty2.default)(_upgradeProductToActi, _UpgradeProducts.CMS_PROFESSIONAL, activationTypes.CMS_PROFESSIONAL), (0, _defineProperty2.default)(_upgradeProductToActi, _UpgradeProducts.CMS_ENTERPRISE, activationTypes.CMS_ENTERPRISE), (0, _defineProperty2.default)(_upgradeProductToActi, _UpgradeProducts.CRM, activationTypes.CRM), (0, _defineProperty2.default)(_upgradeProductToActi, _UpgradeProducts.SERVICE_FREE, activationTypes.SERVICE_FREE), _upgradeProductToActi);
exports.upgradeProductToActivationType = upgradeProductToActivationType;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/constants/productActivation.js
// module id = 475
// module chunks = 5 6